<template>
  <div>
    <div class="logo_con">
      <div class="container portal_logo">
        <h1>
          <img :src="require('../images/logo.svg')" class="brand" />
          <div class="apptitle">
            江阴市地理信息公共服务平台<br /><small class="appeng"
              >Jiangyin City Platform for Common GeoSpatial Information
              Services</small
            >
          </div>
        </h1>
      </div>
    </div>
    <!-- 导航栏 -->
    <nav class="navbar">
      <div class="container">
        <div class="navbar-header">
          <button type="button" class="navbar-toggle collapsed">
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
        </div>
        <div id="navbar" class="collapse navbar-collapse">
          <ul class="nav navbar-nav">
            <li>
              <!-- <a href="http://jiangsu.tianditu.gov.cn/zhenjiang" target="_blank" onclick= getcontent(this)>首页</a> -->
              <a target="_blank" href="#/">首页</a>
            </li>
            <li class="has-items" data-target="onlinemap" id="85">
              <!-- <a href="Emap/map.html" target="_blank" onclick= getcontent(this)>电子地图</a> -->
              <a>地图服务</a>
            </li>
            <li>
              <a href="http://lbs.tianditu.gov.cn/home.html" target="_blank"
                >开发资源</a
              >
            </li>
            <li>
              <a
                href="https://mulu.tianditu.gov.cn/catalog?source=156320281"
                target="_blank"
                >成果目录</a
              >
            </li>

            <li class="has-items" data-target="typical" id="85">
              <a target="_blank" href="#/ExamplePage">典型应用</a>
            </li>
            <li>
              <a href="#/updateLog" target="_blank">更新日志</a>
            </li>
            <!-- <li class="has-items" data-target="childnode" id="85">
              <a href="">县级节点</a>
            </li> -->
          </ul>
          <div class="hover-menu">
            <ul id="onlinemap" class="pc">
              <li>
                <a target="_blank" href="./Emap/">在线地图</a>
              </li>
              <li>
                <a target="_blank" href="#/multiTemporal">多时相影像</a>
              </li>
              <li>
                <a target="_blank" href="#/DownloadCentre">标准地图</a>
              </li>
            </ul>
            <ul id="resourceOnline" class="pc">
              <li>
                <a
                  href="http://lbs.tianditu.gov.cn/server/MapService.html"
                  target="_blank"
                  >地图API</a
                >
              </li>
              <li>
                <a href="http://lbs.tianditu.gov.cn/home.html" target="_blank"
                  >网页API</a
                >
              </li>
              <li>
                <a
                  href="http://lbs.tianditu.gov.cn/server/guide.html"
                  target="_blank"
                  >WEB服务API</a
                >
              </li>
              <li>
                <a
                  href="http://lbs.tianditu.gov.cn/data/dataapi.html"
                  target="_blank"
                  >数据API</a
                >
              </li>
              <li>
                <a href="http://service.tianditu.gov.cn/" target="_blank"
                  >服务资源</a
                >
              </li>
              <!--<li>
								<a href="http://lbs.tianditu.gov.cn/android/guide.html" target="_blank">移动SDK</a>
							</li>-->
            </ul>
            <ul id="typical" class="pc">
              <li>
                <a href="./static/jyjjzb/map/index.html" target="_blank"
                  >江阴市经济指标</a
                >
              </li>
            </ul>
            <ul id="childnode" class="pc">
              <li>
                <a
                  hidefocus
                  href="http://jiangsu.tianditu.gov.cn/danyang/"
                  target="_blank"
                  >丹阳</a
                >
              </li>
              <li>
                <a
                  hidefocus
                  href="http://jiangsu.tianditu.gov.cn/yangzhong/"
                  target="_blank"
                  >扬中</a
                >
              </li>
            </ul>
            <div id="provinceCity" class="district-info pc"></div>
            <div class="city-box">
              <div class="up-arrow"></div>
              <ul class="clearfix"></ul>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script setup>
import { onMounted, defineExpose } from "vue";
import "../js/nav";

onMounted(() => {
  // initMenu("2")
});
function initMenu(index) {
  var activeA = $(".navbar-nav li:nth-child(" + index + ")").children(
    "a:first-child"
  );
  activeA.addClass("navactive");
  activeA.append("<b></b>");
}
defineExpose({ initMenu }); //向父组件暴露需要修改的值
</script>


<style scoped>
@import url("../css/nav.css");
@import url("../css/index.css");

/* 首页改版 */

.brand {
  width: 5.6vw;
  margin-right: 34px;
}
</style>